import { useState } from 'react';
import storage from '../../../util/storage';
import Create from '../../../../useCase/Prospect/Create';
import FetchProspectGateway from '../../../../gateway/Prospect/FetchProspectGateway';
import Authorize from '../../../../useCase/Client/Authorize';
import FetchClientGateway from '../../../../gateway/Client/FetchClientGateway';
import Client from '../../../../domain/Client/Client';
import {Folder} from '../../../../domain/Folder/Folder';
import { roleBackOfficeList } from '../../../../domain/User/Erole';
import { useFolderId } from '../../../../infrastructure/hooks';
import { EModule } from '../../../../domain/User/Emodule';

interface UseProspectReturn {
  isLoading: boolean;
  isVisibleCreateProspect: boolean;
  isVisibleAuthorizeClient: boolean;
  success: string | null;
  errors: Error[] | null;
  handleClick: (action: string) => void;
  readOnlyMode: boolean;
}

const useProspect = (): UseProspectReturn => {
  const { folderId } = useFolderId()
  const clientId = storage.getClientId(folderId)
  const dossierId = folderId

  const [isLoading, setLoading] = useState<boolean>(false)
  const [isVisibleCreateProspect, setVisibleCreateProspect] = useState<boolean>(clientId === null)
  const [isVisibleAuthorizeClient, setVisibleAuthorizeClient] = useState<boolean>(clientId !== null)
  const [success, setSuccess] = useState<string|null>(null)
  const [errors, setErrors] = useState<Error[]|null>(null)
  const userRole = localStorage.getItem('role')
  const formId = storage.getFormId(folderId)
  let readOnlyMode = (userRole && roleBackOfficeList.includes(userRole) && formId === storage.getClientFormId()) ? true : false;
  if (
    formId === storage.getBackOfficeConventionFormId()
    && storage.getAdvisorId(folderId) && storage.getUserInformation()?.user_id != storage.getAdvisorId(folderId)
  ) {
    readOnlyMode = true
  }
      
  const handleClick = (action: string) => {
    if (action === 'create' && dossierId !== null) {
      setLoading(true)
      new Create(new FetchProspectGateway()).execute(dossierId).then(response => {
        if (response instanceof Client) {
          setVisibleCreateProspect(false)

          storage.setClientId(response.id, folderId)

          if (storage.getFormId(folderId) !== storage.getBackOfficeConventionFormId()) {
            new Authorize(new FetchClientGateway()).execute(dossierId, response.id).then(responseAuthorize => {
              if (responseAuthorize instanceof Folder) {
                storage.setAuthorizedClients(responseAuthorize.authorizedClients, folderId)
                setSuccess('common.success-prospect')
              }
            })
          }
        } else {
          setErrors(response)
        }
      }).catch((error) => {
        if (error.response && error.response.data && Array.isArray(error.response.data.errors)) {
          setErrors(error.response.data.errors)
        } else {
          setErrors([{message: 'create-prospect', name: 'create-prospect'}])
        }
      }).finally(() => {
        setLoading(false)
      })

      return false
    }

    if (clientId !== null && dossierId !== null) {
      setLoading(true)
      new Authorize(new FetchClientGateway()).execute(dossierId, clientId).then(response => {
        if (response instanceof Folder) {
          setVisibleAuthorizeClient(false)
          storage.setAuthorizedClients(response.authorizedClients, folderId)
          setSuccess('common.success-client')
        } else {
          setErrors(response)
        }

        setLoading(false)
      }).catch(() => {
        setVisibleAuthorizeClient(true)
      })
    }
  }

  return {
    isLoading,
    isVisibleCreateProspect,
    isVisibleAuthorizeClient,
    success,
    errors,
    handleClick,
    readOnlyMode
  }
}

export default useProspect;
